import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui-kit/card';
import { AddFolderModal } from './components/add-folder-modal';
import { FolderCard } from './components/folder-card';
import { Skeleton } from '@/components/ui-kit/skeleton';
import { Fragment } from 'react';
import { useGetFolderList } from '@/modules/gpt-chats/hooks/use-kb';
import { NoFolders } from './components/no-folders';

const FolderListSkeleton = () => {
  return (
    <Fragment>
      {Array.from({ length: 8 }).map((_, index) => (
        <Card key={index} className="flex h-[180px] flex-col gap-4 rounded-md p-5 shadow-sm">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Skeleton className="h-6 w-6 rounded-md" />
              <Skeleton className="h-6 w-32" />
            </div>
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4" />
            <Skeleton className="h-4 w-24" />
          </div>
        </Card>
      ))}
    </Fragment>
  );
};

export const KBFolderListPage = () => {
  const { t } = useTranslation();
  const { data: folderlistData, isLoading, isFetching } = useGetFolderList();
  const folderlist = folderlistData?.data?.folders || [];

  return (
    <div className="flex flex-col gap-6 mt-6">
      <div className="flex justify-between">
        <h3 className="flex items-center gap-2 text-2xl font-bold tracking-tight">
          {t('KNOWLEDGE_BASE')}
        </h3>
        <div className="flex items-center gap-4">{folderlist.length > 0 && <AddFolderModal />}</div>
      </div>
      <Card>
        <CardContent>
          {/* TODO: filtertoolbar here */}
          {!isLoading && !isFetching && folderlist.length === 0 ? (
            <NoFolders action={<AddFolderModal />} isLoading={isLoading || isFetching} />
          ) : (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {(isLoading || isFetching) && <FolderListSkeleton />}
              {!isFetching &&
                folderlist.map((folder) => <FolderCard key={folder._id} folder={folder} />)}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
